import store from '../store'


const isLoggedIn = (to, from, next) => {

  console.log(to)
  console.log(from)
  if(! store.state.auth.status.loggedIn){
    next('/login')
  }else{
    next()
  }

}



export default {
  isLoggedIn: isLoggedIn
}
